import { Badge } from '@/components/ui/badge';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AttachmentBadge, TAttachment } from './AttachmentBadge';

const MAX_VISIBLE_ATTACHMENTS = 3;

type TAttachmentsProps = {
  attachments?: TAttachment[];
};

export const Attachments = (props: TAttachmentsProps) => {
  const { t } = useTranslation();

  const [showAll, setShowAll] = useState(false);

  const handleShowAll = () => {
    setShowAll(!showAll);
  };

  const visibleAttachments =
    (showAll
      ? props.attachments
      : props.attachments?.slice(0, MAX_VISIBLE_ATTACHMENTS)) ?? [];

  const showMoreButton =
    props.attachments && props.attachments.length > MAX_VISIBLE_ATTACHMENTS;

  const attachmentsRemainingCount =
    (props.attachments?.length ?? 0) - MAX_VISIBLE_ATTACHMENTS;

  if (!props.attachments || props.attachments.length === 0) {
    return null;
  }

  return (
    <>
      <div className='mt-3'>
        <h4 className='font-medium'>{t('Attachments')}:</h4>
      </div>
      <div className='mt-3 flex flex-wrap items-center gap-1'>
        {visibleAttachments.map((attachment, index) => (
          <AttachmentBadge key={index} attachment={attachment} />
        ))}

        {showMoreButton && (
          <Badge
            variant='outline'
            className='bg-card p-2 hover:cursor-pointer hover:bg-accent hover:text-accent-foreground'
            onClick={handleShowAll}
          >
            {showAll ? t('Show less') : `+ ${attachmentsRemainingCount}`}
          </Badge>
        )}
      </div>
    </>
  );
};
